import { PVZI } from '../interfaces/pvz.interface'
import { PVZService } from '../services/pvz.service'
import {
    PVZGetListResponseT,
    PVZGetParamsT,
    PVZUpdateParamsT,
    InvoicesGetParamsT,
    InvoicesGetListResponseT,
    PVZCreateParamsT,
    PVZGetByIDResponseT,
} from '../types/pvz.types'

const pvzService = new PVZService()

class PVZRealisation implements PVZI {
    getPVZByID(distribution_center_id: number): Promise<PVZGetByIDResponseT> {
        return pvzService.getPVZByID(distribution_center_id)
    }

    getList(params: PVZGetParamsT): Promise<PVZGetListResponseT> {
        return pvzService.getList(params)
    }

    updatePVZInfo(params: PVZUpdateParamsT): Promise<void> {
        return pvzService.updatePVZInfo(params)
    }

    createPVZ(payload: PVZCreateParamsT): Promise<void> {
        return pvzService.createPVZ(payload)
    }

    deletePVZ(id: number): Promise<void> {
        return pvzService.deletePVZ(id)
    }

    getInvoicesList(params: InvoicesGetParamsT): Promise<InvoicesGetListResponseT> {
        return pvzService.getInvoicesList(params)
    }

    addUser(pvz_id: number, payload: any): Promise<void> {
        return pvzService.addUser(pvz_id, payload)
    }

    uploadPhoto(pvz_id: number, form_data: FormData): Promise<void> {
        return pvzService.uploadPhoto(pvz_id, form_data)
    }
}

export const pvz = new PVZRealisation()
